import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 5.822c0-.404.288-.731.643-.731h2.22c.441-.013.83-.332.98-.804l.025-.083.096-.327c.058-.2.11-.374.18-.53.283-.616.804-1.043 1.407-1.153.153-.027.314-.027.5-.027h2.898c.186 0 .347 0 .5.027.603.11 1.124.537 1.406 1.153.072.156.123.33.181.53l.096.327c.016.055.02.07.025.083.15.472.616.791 1.057.804h2.143c.355 0 .643.327.643.731s-.288.731-.643.731H3.643c-.355 0-.643-.327-.643-.731"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.352 10.068c.343-.036.65.227.684.589l.417 4.386c.034.361-.217.684-.56.72s-.65-.228-.684-.59l-.417-4.385c-.034-.362.216-.684.56-.72M12.643 10.068c.343.036.594.358.56.72l-.417 4.386c-.034.361-.34.625-.684.589s-.594-.359-.56-.72l.417-4.386c.034-.362.34-.625.684-.59",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.16 18.833h.674c2.32 0 3.479 0 4.233-.738s.83-1.95.985-4.371l.222-3.49c.084-1.314.126-1.972-.253-2.388-.378-.416-1.016-.416-2.294-.416h-6.46c-1.277 0-1.916 0-2.294.416s-.336 1.074-.252 2.388l.222 3.49c.154 2.422.231 3.633.985 4.37.754.74 1.913.74 4.232.74",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }